import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentCourseRepeatRateSummary = (props) => (
  <KpiSummary
    isLoading={props.isLoading}
    title="Audio listening difficulty"
    previousValue={props.currentValue}
    currentValue={props.previousValue}
    formatter={props.formatter}
  />
);

ContentCourseRepeatRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentCourseRepeatRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentCourseRepeatRateSummary;
